<template>
  <div class="main-menu">
    <div @click="toggle">
      <slot/>
    </div>
    <Menu ref="menu" :model="items" :popup="true" />
  </div>
</template>

<script>
import Menu from 'primevue/menu'
import HandlesNavigation from '../../mixins/handles-navigation'
export default {
  name: 'MainMenu',
  mixins: [
    HandlesNavigation
  ],
  components: {
    Menu
  },
  methods: {
    toggle (event) {
      this.$refs.menu.toggle(event)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/nav/MainMenu.vue